module.exports = __webpack_public_path__ + "static/media/8OLA16.da9ded60.jpg";